import "./home.css";
import Header from "components/header/header";
import { useEffect, useState } from "react";

import tiktok from "global_assets/social-icons/tiktok.png";
import instagram from "global_assets/social-icons/instagram.png";
import spotify from "global_assets/social-icons/spotify.png";
import bandcamp from "global_assets/social-icons/bandcamp.png";
// import { shows } from "./assets/shows/shows";
import heartsDoodle from "./assets/images/hearts_doodle.png";
import bigflower from "./assets/images/bigflower.png";
import smallflower from "./assets/images/smallflower.png";
import star from "./assets/images/star.png";
import cherry from "global_assets/logo.png";
import swirl from "./assets/images/swirl.png";
import topright from "./assets/images/topright.png";
import topleft from "./assets/images/topleft.png";
import botright from "./assets/images/botright.png";
import botleft from "./assets/images/botleft.png";
import * as albumService from "../../services/new-album-service.js";
import * as showsService from "../../services/shows-service.js";

function Home() {
  const [newAlbum, setNewAlbum] = useState();
  const [shows, setShows] = useState();
  const fetchAlbum = async () => {
    const response = await albumService.fetchNewAlbum();
    setNewAlbum(response.data);
  };
  const fetchShows = async () => {
    const response = await showsService.fetchShows();
    setShows(response.data);
    console.log(response.data.length);
  };
  useEffect(() => {
    fetchAlbum();
    fetchShows();
  }, []);
  return (
    <>
      <div className="top-page">
        <img src={bigflower} className="bigflower" alt=""></img>
        <img src={smallflower} className="smallflower" alt=""></img>
        <img src={star} className="star" alt=""></img>
        <img src={cherry} className="cherry" alt=""></img>
        <div className="header-container">
          <header className="main-header">CHERRY CRISIS</header>
          <nav className="navigation">
            <ul className="navigationList">
              <li>
                <a href="#shows">Shows</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="/gallery">Gallery</a>
              </li>
              <li>
                <a href="/blog">Blog</a>
              </li>
            </ul>
          </nav>

          <div className="icon-row-top">
            <a href="https://www.tiktok.com/@cherry.crisis?_t=8mQYIEknv0l&_r=1">
              <img src={tiktok} alt="tiktok" />
            </a>
            <a href="https://www.instagram.com/cherry.crisis">
              <img src={instagram} alt="instagram" />
            </a>
            <a href="https://open.spotify.com/artist/2HuOLspUSWpwDlsX9WDblu?si=9VZ9QofBTQeFFpxuqnnrQg">
              <img src={spotify} alt="spotify" />
            </a>
            <a
              href="https://cherrycrisis.bandcamp.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={bandcamp} alt="soundcloud" />
            </a>
          </div>
        </div>
      </div>

      <Header></Header>

      {newAlbum && (
        <div className="home-container">
          <div className="home-image">
            <img
              alt=""
              src={"./assets/new_album/" + newAlbum.image}
              style={{ width: "100%", objectFit: "cover" }}
            />
          </div>
          <div className="home-content crisis-text-color text-start">
            <div className="new-album-title">{newAlbum.title}</div>
            <div className="new-album-description">{newAlbum.description}</div>
            <div className="home-content-bottom-row">
              <a href={newAlbum.link} target="blank">
                <primary-button>Listen Now</primary-button>
              </a>
              <img
                alt=""
                src={heartsDoodle}
                className="hearts-doodle-img d-none d-md-block"
              />
            </div>
          </div>
          <img alt="" className="d-none d-md-block topleft" src={topleft} />
          <img alt="" className="d-none d-md-block topright" src={topright} />
          <img alt="" className="d-none d-md-block botleft" src={botleft} />
          <img alt="" className="d-none d-md-block botright" src={botright} />
        </div>
      )}
      {shows && (
        <div className="home-shows interlude-text-color" id="shows">
          <h1 className="new-order bold text-start pb-2">See Us Live</h1>
          <hr />
          {shows.length > 0 ? (
            shows.map((show, index) => (
              <>
                <div key={index} className="show-item">
                  <div className="date">{show?.date ?? "Unknown Date"}</div>
                  <div className="location">
                    {show?.location ?? "Unknown Location"}
                  </div>
                  <div className="city">{show?.city ?? "Unknown City"}</div>
                  <div className="time">{show?.time ?? "Unknown Time"}</div>
                  <a href={show.link} className="more-info" target="blank">
                    <primary-button>More Information</primary-button>
                  </a>
                </div>
                <hr />
              </>
            ))
          ) : (
            <>
              <br />
              <h2 className="new-order semi-bold">
                Please stay tuned for our upcoming shows!
              </h2>
            </>
          )}
          <img alt="" className="d-none d-md-block swirl" src={swirl} />
        </div>
      )}
    </>
  );
}

export default Home;
